// removed by extract-text-webpack-plugin
module.exports = {"header":"_3kRL4BDrpy vr vr_x1","card":"aiVgxudQuJ","details":"_20rpELl7PZ"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Documents/Documents.module.less
// module id = 983
// module chunks = 3